import { getUserUrl } from '@domain/routes/urls';
import { Avatar, AvatarSize } from '../../Avatar/Avatar';
import { Button } from '../../Clickables/Buttons/Button';
import { InternalLink } from '../../Clickables/InternalLink/InternalLink';
import { Heading } from '../../Heading/Heading';
import { Modal } from '../../Modal/Modal';
import { ModalBody } from '../../Modal/ModalBody';
import { Text } from '../../Text/Text';

export interface IQuoteProps {
  bodyText: string;
  username: string;
  userImageUrl?: string;
  userDescription?: string | null;
  className?: string;
  title?: string;
}

const MAX_TEXT_LENGTH = 160;

export const QuoteCard = ({
  bodyText,
  username,
  userImageUrl,
  userDescription,
  className = '',
  title = '',
}: IQuoteProps) => (
  <div
    className={`bg-lake-fog flex size-full flex-col gap-2 rounded-md p-4 md:rounded-lg ${className}`}
  >
    <div className="flex items-center">
      <Avatar
        alt="Pro Angler tip for Species"
        size={AvatarSize.REVIEW_SMALL}
        src={userImageUrl ?? ''}
      />
      <div className="ml-2 flex-col">
        <InternalLink to={getUserUrl(username)} variant="textPrimary">
          <Text variant="xs" className="text-trench m-0 line-clamp-1 font-semibold text-ellipsis">
            {username}
          </Text>
        </InternalLink>
        <Text variant="xs" className="text-abyss m-0">
          {userDescription}
        </Text>
      </div>
    </div>
    <div className="flex flex-col gap-1">
      {title && (
        <Heading as="p" className="m-0" variant="2xs">
          {title}
        </Heading>
      )}
      <Text
        variant="sm"
        className="text-trench mb-0 line-clamp-4 break-words hyphens-auto whitespace-pre-line"
      >
        {bodyText}
      </Text>
    </div>
    {bodyText.length > MAX_TEXT_LENGTH && (
      <Text variant="sm" className="mb-0 flex justify-end">
        <Modal
          trigger={props => (
            <Button
              size="xs"
              variant="textNone"
              className="text-trench font-heading p-0 p-1.5 text-xs font-medium"
              {...props}
            >
              Read More
            </Button>
          )}
        >
          <ModalBody className="mt-4">
            <Text className="mb-3 whitespace-pre-line">{bodyText}</Text>
            <div className="flex flex-row">
              <Text className="mb-0 ml-auto" variant="sm">
                {username}
              </Text>
            </div>
          </ModalBody>
        </Modal>
      </Text>
    )}
  </div>
);
